angular.module( 'acme.view.application.programs.detail.chart', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.programs.detail.chart.controllers',
  'acme.common.directive.gantt'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var programsDetailChart = {
        name: 'application.programsDetail.chart',
        url: '/chart',
        views: {
          "subview-main": {
            controller: 'ProgramsDetailChartController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/programs/detail/chart/chart.tpl.html'
          }
        },
        data: {
          pageTitle: 'Event Template'
        },
        resolve: {
          ResolveViewData: [ 'ResolveViewData', function(ResolveViewData) {
            return ResolveViewData;
          }],
          gantt: ['$q', function($q) {
            var q = $q.defer();

            // Usage
            $.cachedScript( "/assets/dhtmlxgantt.js" ).done(function( script, textStatus ) {
              q.resolve('done');
            });

            return q.promise;

          }]
        }
      };

    $stateProvider
      .state(programsDetailChart);
});
